import React, { useEffect, useState } from 'react';
import './cpdu-printable.styles.scss'
import { useSelector } from 'react-redux'
import { useNavigate, useParams } from 'react-router-dom';
import { deobfuscateString } from '../../../utils/obfuscation';
import FullPageLoader from '../../SHARED/loader/full-page-loader.component';
import EvidenceIL from './evidence-il.component';
import { getCompletedEvalDataFromFirestore } from '../../../utils/getDataFromDb';
import UIkit from 'uikit';
import { format, set } from 'date-fns';
import html2pdf from 'html2pdf.js';

const CpduPrintable = () => {

  const userProfile = useSelector(state => state.userData.userProfile);
  const [ loading, setLoading ] = useState(true);
  const [ prefillData, setPrefillData ] = useState(null);
  const { urlData } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    // if (!userProfile || !urlData) return;
    // Decode and parse the URL data
    const decodedString = deobfuscateString(urlData);
    // console.log(`decodedString: ${decodedString}`);
    if (!decodedString) {
      navigate('/404')
    };
    const {evalId, cstKey} = JSON.parse(decodedString);
    // console.log(`evalId: ${evalId}, cstKey: ${cstKey}`);
    getPrefillData(evalId, cstKey);
  }, [userProfile, urlData])

  async function getPrefillData(evalId, cstKey) {
    console.log(evalId, cstKey);
    // getCompletedEvalDataFromRtDb({
    //   'evalId': evalId,
    //   'cstKey': cstKey,
    //   'callback': callback
    // })
    getCompletedEvalDataFromFirestore({
      'evalId': evalId,
      'cstKey': cstKey,
      'callback': callback
    });
    function callback(data) {
      console.log(data);
      if (!data) {
        setLoading(false);
        UIkit.modal.alert('No completed evaluation data found. Please contact the IPA office for assistance.');
        return;
      }
      const prefill = {
        'fName': data.user.fName,
        'lName': data.user.lName,
        'title': data.eval.item.title,
        'hours': data.comp.hours ?? data.eval.hours,
        'startDate': format(new Date(data.comp.eventDate), "P"),
        'endDate': format(new Date(data.comp.eventDate), "P"),
        'currentDate': format(new Date(), "P"),
        'iein': data.user.iein,
        'state': data.comp.state ? data.comp.state : 'Illinois',
        'pres': 
          data.eval.pres 
          ? data.eval.pres 
          : data.eval.platform 
          ? data.eval.platform 
          : (
            data.eval.source === 'bridge' ||
            data.eval.source === 'zoomWebinar' ||
            data.eval.source === 'mc'
          )
          ? 'Ed Leaders Network' 
          : 'Illinois Principals Association',
      }
      if (data.comp.source === 'checkinout') {
        prefill.fName = data.comp.fName;
        prefill.lName = data.comp.lName;
        prefill.iein = data.comp.iein;
      } 
      setLoading(false);
      setPrefillData(prefill);
    }
    
  }

  function printPage() {
    const timeout = setTimeout(() => {
      try {
        if(!document.execCommand('print', false, null)) {
          window.print()
        }
      } catch {
        window.print()
      }
      clearTimeout(timeout);
    }, 500);
  }

  function generatePDF() {
      // Choose the element that your content will be rendered to.
      const element = document.getElementById("document-content");
      // Choose the element and save the PDF for your user.
      html2pdf().from(element).save();
    }

  return (
    <div className='cpdu-printable'>
      <div className='cpdu-printable-content'>
        <div>
          <div id='print-button'>
            <div className="g-space-2"></div>
            <div className='buttons'>
              {/* <button
                className='g-button'
                onClick={() => generatePDF()}
              >
                Download CPDU Document
              </button> */}
              <button

                className='g-button'
                onClick={() => printPage()}
              >
                Print Evidence Document
              </button>
            </div>
            <div className="g-space-1"></div>
            <p className='meta'>
              To download a copy of this document, click the "Print Evidence Document" 
              button and choose "Save as PDF" as your printer.
            </p>
          </div>
          {
            (!loading && prefillData) 
            ?
            (!prefillData.state || prefillData.state.toLowerCase() === 'illinois') 
            ?
            <div className='document-content' id='document-content'>
              <EvidenceIL prefillData={prefillData} />
            </div>
            :
            (prefillData.state.toLowerCase() === 'new york')
            ?
            <h3 className='center'>New York Evidence of Completion Coming Soon!</h3>
            :
            (prefillData.state.toLowerCase() === 'alaska')
            ?
            <h3 className='center'>Alaska Evidence of Completion Coming Soon!</h3>
            :
            null
            :
            null
          }
        </div>
      </div>
      <FullPageLoader show={loading} text={'Loading Evidence of Completion...'} />
    </div>
    )
}

      export default CpduPrintable